/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modalText[_ngcontent-%COMP%]{max-height:500px;overflow:scroll;margin-top:-20px;margin-bottom:-20px;padding-top:20px;padding-bottom:20px}\n/*# sourceMappingURL=terms.component.css.map*/"];
export { styles as styles };
